import {formatDateTime} from '../../utils/formatDateTime';
import {drawSensorChart} from './draw-sensor-chart';

let pointStyle = "point { size: 4; shape-type: circle; fill-color: #ffffff; opacity: 1; stroke-color: #3c3c3b; stroke-width: 2}";

/*
* Get single sensor data.
* */
export const getSensorData = function (sensorId, sensorSpan, chartContainerId, chartType, curSensorLabel) {
    const buildingId = document.querySelector('#building_id').value;
    let span = sensorSpan || 'WEEK';
    if(window.location.href.includes("/buildingDetails/measurements/")) {
        let redirectUrl = `/buildingDetails/measurements/${sensorId}?chartStyle=line&span=${span}`;
        window.location.replace(redirectUrl);
        return;
    }
    let apiUrl = `/api/building/${buildingId}/control-point/${sensorId}/history?span=${span}`;
    fetch(apiUrl)
        .then(response => {
            return response.json();
        })
        .then(resp => {
            const {zone} = resp.building || [];
            const {id, label} = resp.controlPoint || [];
            const {data, pattern, start, end, span, lineChartOptions} = resp.history || [];
            const timeZoneOffset = resp.timeZoneOffset;

            // Create table with single sensor data.
            const sensorData = [];

            for (let i = 0; i < data.length; i++) {
                let newData = [];
                const curDateTime = formatDateTime(data[i][0]);

                // console.log('data...:', data);
                newData.push(new Date(
                    curDateTime.year,
                    curDateTime.month,
                    curDateTime.day,
                    curDateTime.hour,
                    curDateTime.minute,
                    curDateTime.second
                ));

                newData.push(data[i][1]);
                newData.push(50);
                newData.push(70);

                if ('LineChart' === chartType) {
                    newData.push(pointStyle);
                }

                sensorData.push(newData);
            }

            // Pass single sensor data and create a chart in sensorChart().
            drawSensorChart(sensorData, chartContainerId, chartType, curSensorLabel, lineChartOptions, timeZoneOffset);
        })
        .catch(err => {
            console.error('Error getSensorData()', err);
        })
};
